"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // ToDo: Fill out/finish class

var FloTx = /*#__PURE__*/function () {
  function FloTx(floData) {
    _classCallCheck(this, FloTx);

    this._source = floData;
    this.floData = undefined;
    this.blockhash = undefined;
    this.size = undefined;
    this.txid = undefined;
    this.time = undefined;
    this.fromJSON(floData);
  }
  /**
   * Return FloData
   * @returns {*}
   */


  _createClass(FloTx, [{
    key: "getFloData",
    value: function getFloData() {
      return this.floData;
    }
    /**
     * Return Block Hash
     * @returns {*}
     */

  }, {
    key: "getBlockHash",
    value: function getBlockHash() {
      return this.blockhash;
    }
    /**
     * Return Size
     * @returns {*}
     */

  }, {
    key: "getSize",
    value: function getSize() {
      return this.size;
    }
    /**
     * Get TXID
     * @returns {string|*}
     */

  }, {
    key: "getTXID",
    value: function getTXID() {
      return this.txid;
    }
    /**
     * Get Time
     * @returns {string|*}
     */

  }, {
    key: "getTime",
    value: function getTime() {
      return this.time;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return !!(this.blockhash && this.txid && this.floData);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(floData) {
      if (typeof floData === 'string') {
        floData = JSON.parse(floData);
      }

      floData = floData.tx;

      if (floData.floData) {
        this.floData = floData.floData;
      }

      if (floData.blockhash) {
        this.blockhash = floData.blockhash;
      }

      if (floData.size) {
        this.size = floData.size;
      }

      if (floData.txid) {
        this.txid = floData.txid;
      }

      if (floData.time) {
        this.time = floData.time;
      }
    }
  }]);

  return FloTx;
}();

var _default = FloTx;
exports.default = _default;